import { render, staticRenderFns } from "./SubscriptionDesktop.vue?vue&type=template&id=37d7daa9&scoped=true"
import script from "./SubscriptionDesktop.vue?vue&type=script&lang=js"
export * from "./SubscriptionDesktop.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionDesktop.vue?vue&type=style&index=0&id=37d7daa9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d7daa9",
  null
  
)

export default component.exports